export const authCookieKey = 'tokenKey';
export const currentUserMenuValue = 'currentUserMenuValue';
export const currentUserRole = 'currentUserRole';
export const Doctor = 'Doctor';
export const Nurse = 'Nurse';
export const Ancillary = 'Ancillary';
export const Administrator = 'Administrator';
export const Patient = 'Patient';

//////////////////////////////   Localhost   ///////////////////////////
//export const authorizationServerUrl = 'http://localhost:35427';
//export const pathMatch = '/UMRPortals';
//export const scopes = ['UMRPortals', 'offline_access', 'openid & acr_values=UMHLD'];
//export const resourceServerUrl = 'http://localhost:14241';
//export const recaptchaSitekey = '6LdNzJYUAAAAAKAay55ieNTFJnGTD4rRI3AXAAdj';

//////////////////////    192.168.1.12  New Server   //////////////////////////
//export const authorizationServerUrl = 'http://192.168.1.12/UMRPortalsAPIAuthorizationServer';
//export const pathMatch = '/UMRPortals';
//export const scopes = ['UMRPortals', 'offline_access', 'openid & acr_values=UMHLD'];
//export const resourceServerUrl = 'http://192.168.1.12/UMRPortalsAPIResourceServer';
//export const recaptchaSitekey = '6LdNzJYUAAAAAKAay55ieNTFJnGTD4rRI3AXAAdj';

//////////////////////    172.16.1.11 TEST   //////////////////////////
//export const authorizationServerUrl = 'https://www.umrtest.com/UMRPortalsAPIAuthorizationServer';
//export const pathMatch = '/UMRPortals';
//export const scopes = ['UMRPortals', 'offline_access', 'openid & acr_values=UMHLD'];
//export const resourceServerUrl = 'https://www.umrtest.com/UMRPortalsAPIResourceServer';
//export const recaptchaSitekey = '6LdNzJYUAAAAAKAay55ieNTFJnGTD4rRI3AXAAdj';

//////////////////////////    192.168.1.12 PRODUCTION  //////////////////////////
export const authorizationServerUrl = 'https://universalmedicalrecord.com/UMRPortalsAPIAuthorizationServer';
export const pathMatch = '/UMRPortals';
export const scopes = ['UMRPortals', 'offline_access', 'openid & acr_values=UMHLD'];
export const resourceServerUrl = 'https://universalmedicalrecord.com/UMRPortalsAPIResourceServer';
export const recaptchaSitekey = '6LdNzJYUAAAAAKAay55ieNTFJnGTD4rRI3AXAAdj';

//////////////////////////////   Localhost SSL   ///////////////////////////
//export const authorizationServerUrl = 'https://localhost:44315/';
//export const pathMatch = '/UMRPortals';
//export const scopes = ['UMRPortals', 'offline_access', 'openid & acr_values=UMHLD'];
//export const resourceServerUrl = 'https://localhost:44366/';
//export const recaptchaSitekey = '6LdNzJYUAAAAAKAay55ieNTFJnGTD4rRI3AXAAdj';

////////////////    SPIKE   /////////////////////
//export const authorizationServerUrl = 'https://172.16.205.67:1112';
//export const pathMatch = '/UMRPortals';
//export const scopes = ['UMRPortals', 'offline_access', 'openid & acr_values=UMHLD'];
//export const resourceServerUrl = 'https://172.16.205.67:2222';
//export const recaptchaSitekey = '6LdNzJYUAAAAAKAay55ieNTFJnGTD4rRI3AXAAdj';

export const allPermissions = ['Add New Applicant', 'Allowed IP', 'Applicant Degree', 'Applicant Ownership', 'Applicant Skill', 'Applicant Transfer', 'Applicants', 'Assign Recruiter Role', 'Calendar', 'Cold Tracking', 'Configure Field Access Permission', 'Contact', 'Email', 'Follow-up', 'General Population', 'Hot Tracking', 'Information', 'Institution Information', 'Institution Type Information', 'Interview', 'Job Attributes', 'Job Skills', 'Manage Profile', 'Manage Recruiter', 'Manage Role', 'Others', 'Pending', 'Placement', 'Position Information', 'Profiles', 'Recruiter', 'Send Out', 'Settings', 'User Mail', 'User Mail Configuration', 'User Mail Template', 'User Settings', 'View By Applicant', 'View by Institution', 'Logout'];
